import store from '@/store';

const placeholderIcon = require('@/assets/images/image-placeholder.png');

let isDropdownOpen = false; // global to this file

const TextAIHandle = {
  name:   'textAIHandle',
  props:  {},
  events: {},
  css:    ['otherTarget'],
  render(moveable, React) {
    const rect     = moveable.getRect();
    const { pos2 } = moveable.state;

    const dropdownStyle = {
      position:     'absolute',
      top:          '-4%',
      left:         '120%',
      background:   '#fff',
      border:       '1px solid #ccc',
      borderRadius: '12px',
      padding:      '4px 0',
      listStyle:    'none',
      margin:       0,
      zIndex:       9999,
    };

    return React.createElement(
      'div',
      {
        class: 'extended-button text-ai-button d-flex flex-column align-items-center justify-content-center mt-5',
        style: {
          position:        'absolute',
          left:            '0px',
          top:             '78px',
          transform:       `translate(${pos2[0]}px, ${pos2[1]}px) rotate(${rect.rotation}deg) translate(10px, 0px)`,
          transformOrigin: '0 0',
          cursor:          'pointer',
        },
        key:         'text-ai-handle',
        onMouseDown: (event) => {
          event.stopPropagation();
          event.preventDefault();
        },
        onClick: (event) => {
          event.stopPropagation();
          isDropdownOpen = !isDropdownOpen;
          moveable.updateTarget(); // re-render handle
        },
      },
      // Show dropdown only if open
      isDropdownOpen
        && React.createElement(
          'ul',
          {
            style:       dropdownStyle,
            onMouseDown: (e) => { e.stopPropagation(); e.preventDefault(); },
            class:       'text-ai-dropdown',
          },
          React.createElement(
            'li',
            {
              class:   'text-nowrap',
              key:     'option-1-text-ai',
              onClick: (event) => {
                event.stopPropagation();
                isDropdownOpen = false;
                store.commit('activeProduct/updateShowTextAiGenModal', true);
                moveable.updateTarget();
              },
            },
            [
              React.createElement('img', {
                src:    placeholderIcon,
                width:  16,
                height: 16,
                key:    'img-1',
              }),
              'Generate Text',
            ],
          ),
          React.createElement(
            'li',
            {
              class:   'text-nowrap',
              key:     'option-2-text-ai',
              onClick: (event) => {
                event.stopPropagation();
                isDropdownOpen   = false;
                const { target } = moveable.state;
                const text       = target ? target.innerText : '';
                store.commit('activeProduct/updateCurrentObjectText', text);
                setTimeout(() => {
                  store.commit('activeProduct/updateShowTextAiRewriteModal', true);
                });
                moveable.updateTarget();
              },
            },
            [
              React.createElement('img', {
                src:    placeholderIcon,
                width:  16,
                height: 16,
                key:    'img-1',
              }),
              'Rewrite Existing Text',
            ],
          ),
        ),
    );
  },
};
export default TextAIHandle;
